import { Opacity, RGBAColor } from '@/types/types';

const isValidRGBAColor = (color: string): color is RGBAColor => {
    const rgbaPattern = /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*(?:,\s*\d+(?:\.\d+)?)?\s*\)$/;
    return rgbaPattern.test(color);
};

const isValidRGBColor = (color: string): boolean => {
    const rgbPattern = /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/;
    return rgbPattern.test(color);
};

export const replaceOrAddOpacity = (opacity: number) => (color: string) =>
    color.replace(/,\s*(\d+(\.\d+)?)\s*\)$/, `,${opacity})`);

const ensureRGBAWithOpacity = (color: string): string => {
    if (isValidRGBAColor(color)) {
        const match = color.match(
            /^rgba\((\s*\d+\s*,\s*\d+\s*,\s*\d+\s*)(?:,\s*(\d+(\.\d+)?))?\s*\)$/,
        );
        if (match) {
            const baseRgba = match[1];
            if (match[2] === undefined) {
                return `rgba(${baseRgba},1)`;
            }
        }
        return color;
    }
    if (isValidRGBColor(color)) {
        return color.replace('rgb', 'rgba').replace(/\)$/, ',1)');
    }
    return color;
};

export const addOpacityToThemeColor = (colour?: string, opacity?: Opacity): string => {
    if (!colour || typeof colour !== 'string') {
        console.error(`Invalid or no colour provided: ${colour}`);
        return '';
    }

    const trimmedColour = colour.trim();

    if (!isValidRGBColor(trimmedColour) && !isValidRGBAColor(trimmedColour)) {
        console.error(`Invalid colour format: ${trimmedColour}`);
        return trimmedColour;
    }

    if (opacity === undefined || typeof opacity !== 'number' || opacity < 0 || opacity > 1) {
        console.error(`Invalid opacity: ${opacity}`);
        return trimmedColour;
    }

    const normalizedColor = ensureRGBAWithOpacity(trimmedColour);
    return replaceOrAddOpacity(opacity)(normalizedColor);
};
